
<template>
  <div :class="$style.root">
    <i18nLink
      :to="{ name: 'exhibitions-slug-documentation' }"
      :class="$style.link"
    >
      <LayoutImageWithCaptionComponent>
        <template #image>
          <CoreImageComponent
            v-if="getAttributes(image)"
            :image="getAttributes(image)"
            :showCaption="false"
          />
        </template>

        <template #caption>
          <div :class="$style.label">
            {{ $t('pages.exhibitionsSlug.images.linkToAll') }}
          </div>
        </template>

      </LayoutImageWithCaptionComponent>
    </i18nLink>
  </div>
</template>

<script lang="ts" setup>
import { sample } from 'lodash-es'

const props = defineProps<{
  images: array
}>()

const image = sample(props.images)

const getAttributes = baseStrapiGetAttributes
</script>

<style module>
.root {
}

.link {
  composes: reset-link font-helvetica font-size-small from global;
  text-decoration-line: underline;
}

.link:hover {
  text-decoration-line: none;
}
</style>
